import React from 'react';
import PropTypes from 'prop-types';

const DispatchTableHead = ({
  title,
  span,
  onAddClick,
  onOptionClick,
  active,
  userType,
  isTeamCaptain,
  captainNo,
  numberOfItems,
}) => {
  return (
    <thead>
      <tr>
        <th className="content-box-secondary-header" colSpan={span.toString()}>
          <div className="title">
            {title}
            {numberOfItems > 0 && <em> ( {numberOfItems} )</em>}
          </div>
          {userType === 'admin' && (
            <div className="settings">
              <i
                className={
                  active
                    ? 'fa copy-icon fa-files-o highlight_icon'
                    : 'fa copy-icon fa-files-o'
                }
                aria-hidden="true"
                onClick={() => onOptionClick()}
              />
              <i
                className="add-item fa fa-plus-square"
                aria-hidden="true"
                onClick={() => onAddClick()}
              />
            </div>
          )}
          {isTeamCaptain && (
            <div className="settings">
              <a
                href={`https://www.moncasa.ca/srj-moncasa/login.php?Chef=${captainNo}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  className="add-item fa fa-plus-square-o"
                  aria-hidden="true"
                  onClick={() => onAddClick()}
                />
              </a>
            </div>
          )}
        </th>
      </tr>
    </thead>
  );
};

DispatchTableHead.propTypes = {
  title: PropTypes.string,
  span: PropTypes.number,
  onAddClick: PropTypes.func,
  onOptionClick: PropTypes.func,
  active: PropTypes.bool,
  secondActive: PropTypes.bool,
};

export default DispatchTableHead;
